import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { ConfigService} from '../config/config-service';

@Injectable()
export class LoginService {
  private config: ConfigService;
  
	constructor(private http: Http) {
		this.config = new ConfigService();
  }

  auth(data): any{
    let url = sessionStorage.getItem('host_api') + '/auth';
		let params = data;
		let headers = new Headers({ 'Content-type': 'application/json' });

    let options = new RequestOptions({ headers: headers });
    
    return this.http.post(url, params, options).map((res: Response) => {
      let json = res.json();

      if( json.data.token ){
        // GUARDAR DATOS DE INICIO DE SESION
      }

      return json;
    });
  }
  
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/login/login.service.ts